import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Instalacion/editInstalacion`, method: 'POST', body: values, token: token})
}
